var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4565 5.04348C11.4565 4.46718 11.9237 4 12.5 4C13.0763 4 13.5435 4.46718 13.5435 5.04348V18.9565C13.5435 19.5328 13.0763 20 12.5 20C11.9237 20 11.4565 19.5328 11.4565 18.9565V5.04348Z",
    fill: "#004529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54348 13.0435C4.96718 13.0435 4.5 12.5763 4.5 12C4.5 11.4237 4.96718 10.9565 5.54348 10.9565L19.4565 10.9565C20.0328 10.9565 20.5 11.4237 20.5 12C20.5 12.5763 20.0328 13.0435 19.4565 13.0435H5.54348Z",
    fill: "#004529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.4684e3c69291c941f1860dd640b8bf23.svg";
export { ForwardRef as ReactComponent };